import * as React from 'react';
import { css, html } from 'react-strict-dom';
import { Style } from 'src/constants';

type Props = {
  /** Destructive action, kept away from the buttons people reach for. */
  left?: React.ReactNode;
  children: React.ReactNode;
};

export default function ModalFooter({ left, children }: Props) {
  return (
    <html.div style={[Style.row, Style.alignCenter, styles.footer]}>
      {/* Always present so the actions stay pinned right without it. */}
      <html.div style={[Style.row, Style.alignCenter, styles.left]}>
        {left}
      </html.div>
      <html.div style={[Style.row, Style.alignCenter, styles.group]}>
        {children}
      </html.div>
    </html.div>
  );
}

const styles = css.create({
  footer: {
    gap: 8,
    paddingTop: 12,
    paddingBottom: 20,
    paddingInline: 20,
  },
  group: {
    gap: 8,
  },
  left: {
    flexGrow: 1,
    gap: 8,
  },
});
